
$('.seemore').on('click', function () {
  // Doing this on the front end for now. If we ever have more than 20 of anything then we should probably move this to the backend.
  const selector = $(this).attr('data-select');

  $(this).siblings('.' + selector).removeClass('hidden-5');
  $(this).hide();

  return false;
});
